/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Backbone from 'backbone';

import TooltipView from '@/views/TooltipView';
import showErrorMessage from '@/util/showErrorMessage';

import EmptyView from '../EmptyView';

import './SideNavContentView.css';
import tmplSideNavContentView from './SideNavContentView.hbs';

const SideNavContentView = View.extend({
  template: tmplSideNavContentView,

  templateContext() {
    const migrated = this.options.migrated;
    return {
      migrated
    }
  },

  id() {
    return this.model.get('id');
  },

  attributes: {
    role: 'tabpanel'
  },

  className() {
    const baseClass = 'side-nav-content-view';
    if (this.options.expanded) {
      return baseClass;
    } else {
      if (this.options.isContentActive) {
        return `${baseClass} tab-pane active`;
      }
      return `${baseClass} tab-pane`;
    }
  },

  ui: {
    contentContainer: '.content-container',
    tooltip: '.tooltip-container'
  },

  regions: {
    contentContainer: '@ui.contentContainer',
    tooltip: '@ui.tooltip'
  },

  childViewEvents: {
    'has:errors': 'onHasErrors'
  },

  onHasErrors() {
    const sectionName = this.model.get('title');
    showErrorMessage({
      errorCode: `${sectionName}Error`,
      errorTitle: 'Validation Warning',
      errorMessage: `The ${sectionName} section did not pass validation. Your information has been saved but not submitted.`
    });
    this.showValidation = true;
  },

  onRender() {
    this.showValidation = false;

    let viewToRender = this.model.get('view');
    if (!viewToRender) {
      viewToRender = new EmptyView();
    }
    viewToRender.sideNavView = this.options.sideNavView;
    this.showChildView('contentContainer', viewToRender);

    const tooltip = this.model.get('tooltip');
    if (tooltip) {
      this.showChildView(
        'tooltip',
        new TooltipView({
          model: new Backbone.Model({
            tooltipText: tooltip.text,
            placement: tooltip.placement
          })
        })
      );
    }
  },

  makeInactive() {
    this.$el.removeClass('active');
    this.$el.hide();
  },

  makeActive() {
    this.$el.addClass('active');
    this.$el.show();
  },

  reloadData() {
    const loader = this.model.get('loader');
    const loaderOptions = this.model.get('loaderOptions');
    if (!loader || !loaderOptions) return;

    loaderOptions.showValidation = this.showValidation === true ? true : loaderOptions.showValidation;
    const view = this.model.get('view');
    view.initialize({ viewPromise: loader(loaderOptions) });
  }
});

export default SideNavContentView;
